import AbstractRepository from "@/repositories/AbstractRepository";

export default class CatalogRepository extends AbstractRepository {
    protected static resource: string = "ptf-zerowaste-catalog";

    protected static defaultFields: string[] = [
        "uuid",
        "name",
        "code",
        "startDate",
        "armisValidation",
        "document.uuid",
        "document.clientOriginalFileName",
        "document.link",
        "typeCatalog",
    ];
}
